import { Show } from "solid-js";
import { ToolTip } from "../../patcher/patch-types";
import { createID } from "../../patcher/utils/html";

export default function (tooltip: ToolTip) {
  const id = createID();
  return (<div class="patch tooltip-patch form-check form-switch">
    <input class="form-check-input" type="checkbox" id={id} disabled />
    <label for={id} class="form-check-label">{tooltip.name}</label>
    <Show when={tooltip.patch.tooltip}>
      <div class="badge tip text-bg-secondary" innerHTML={tooltip.patch.tooltip}></div>
    </Show>
    <Show when={tooltip.patch.danger}>
      <div class="badge tip text-bg-danger" innerHTML={tooltip.patch.danger}></div>
    </Show>
  </div>)
}
